
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30.179 22.205"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 348","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.85 19.903h-1.978v1.973a.329.329 0 01-.329.329h-.658a.329.329 0 01-.329-.329v-1.973h-1.972a.329.329 0 01-.329-.329v-.658a.329.329 0 01.329-.329h1.975v-1.973a.329.329 0 01.329-.329h.658a.329.329 0 01.329.329v1.973h1.975a.329.329 0 01.329.329v.658a.329.329 0 01-.329.329zm-6.978-.662a4.432 4.432 0 00.151 1.145c-.874.077-1.88.125-3.036.125-4.6 0-6.854-.751-7.679-1.118a.712.712 0 01-.385-.6v-1.571a4.619 4.619 0 014.088-4.569.382.382 0 01.23.063 6.372 6.372 0 007.5 0 .382.382 0 01.23-.063 4.622 4.622 0 013.483 2.312 4.08 4.08 0 00-.413-.021 4.233 4.233 0 00-4.169 4.297zm-2.885-6.951a4.769 4.769 0 114.775-4.769 4.771 4.771 0 01-4.772 4.768z"}}),_c('path',{attrs:{"data-name":"add-user-c","d":"M17.924 17.151h-1.978v1.973a.329.329 0 01-.329.329h-.658a.329.329 0 01-.329-.329v-1.973h-1.972a.329.329 0 01-.329-.329v-.658a.329.329 0 01.329-.329h1.975v-1.973a.329.329 0 01.329-.329h.658a.329.329 0 01.329.329v1.973h1.975a.329.329 0 01.329.329v.658a.329.329 0 01-.329.329zm-6.978-.662a4.432 4.432 0 00.151 1.145c-.874.077-1.88.125-3.036.125-4.6 0-6.854-.751-7.679-1.118a.712.712 0 01-.385-.6V14.47a4.619 4.619 0 014.088-4.569.382.382 0 01.23.063 6.372 6.372 0 007.5 0 .382.382 0 01.23-.063 4.622 4.622 0 013.483 2.312 4.08 4.08 0 00-.413-.021 4.233 4.233 0 00-4.169 4.297zM8.061 9.538a4.769 4.769 0 114.775-4.769 4.771 4.771 0 01-4.772 4.768z"}})])])
          )
        }
      }
    